module.exports = __webpack_public_path__ + "static/media/vampire_head.b2a37a4f.png";